module.exports = {"370681001":"东莱街道","370681002":"龙港街道","370681003":"新嘉街道","370681004":"徐福街道","370681005":"东江街道","370681102":"黄山馆镇","370681103":"北马镇","370681104":"芦头镇","370681106":"下丁家镇","370681107":"七甲镇","370681108":"石良镇","370681109":"兰高镇","370681110":"诸由观镇","370681401":"山东龙口高新技术产业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370681.json
// module id = 1295
// module chunks = 0